import { AccessControlCode } from '@shared/constants';
import React from 'react';
import { useAppSelector } from '../../hooks/useRedux';
import { selectHasAccessControl } from '../../store/auth/authSelectors';

interface AccessControlGateProps {
  control: AccessControlCode | string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const AccessControlGate: React.FC<AccessControlGateProps> = ({
  control,
  children,
  fallback = null,
}) => {
  const hasAccess = useAppSelector(selectHasAccessControl(control));

  if (!hasAccess) {
    return fallback as React.ReactElement | null;
  }

  return children as React.ReactElement | null;
};
